
import { countCarrito } from "./aLogin";
//import { desencriptarTramaAES } from "../utils/Encriptar";
import ReactGA from 'react-ga';
//import { agregarEventosAnalytics } from "../utils/FuncionesGenerales";
import { urlConsultarDuplicidadHogar, urlConsultarDuplicidad, urlConsultarListaNegra, urlModificarCarrito, urlListarCarrito, urlGuardarDatosAdiconalesCarrito, urlValidarPlacaSinPolizaCarrito, urlCarritoHogar, urlListarSeccionesCoberturasHogar, urlListarCoberturasHogarAdvance, urlCalcularPrimasHogar, urlRecuperarCarritoHogar, urlGenerarEnviarCotizacionHogar, urlConsultarDuplicidadPymes, urlModificarCarritoComparador, urlModificarCarritoPits, urlValidarEmailidentificacion, urlModificarCarritoComparadorRenovaciones, urlModificarCarritoPitsRenovaciones, urlModificarCarritoExternoRenovaciones, urlRecalcularCarrito, urlModificarCarritoRenovacion } from "../../constants/urls";
import { setConsultaPlaca } from "../actions/aCotizacion"
import { createAction } from 'redux-actions'
import { apiGet, apiPost } from "../../api";
import { httpClient } from "../../api/httpClient";

export const PRODUCTO_CARRITO_HAS_ERRORED = "PRODUCTO_CARRITO_HAS_ERRORED";
export const SET_DATA_CARRITO_DETALLE = "SET_DATA_CARRITO_DETALLE";
export const SET_DATA_PlANES_COMPARADOR = "SET_DATA_PlANES_COMPARADOR";
export const PRODUCTO_CARRITO_IS_LOADING = "PRODUCTO_CARRITO_IS_LOADING";
export const LIMPIAR_CARRITO = "LIMPIAR_CARRITO";
export const LIMPIAR_LISTA_NEGRA = "LIMPIAR_LISTA_NEGRA";
export const VALIDAR_PLACAS_POLIZA = "VALIDAR_PLACAS_POLIZA";
export const MSG_VALIDAR_PLACAS_POLIZA = "MSG_VALIDAR_PLACAS_POLIZA";
export const LIMPIAR_DATOS_VALIDACIONES_PLACA = "LIMPIAR_DATOS_VALIDACIONES_PLACA";


ReactGA.initialize('UA-131241061-1');

export const ProductosCarritoHasErrored = (error) => ({
  type: PRODUCTO_CARRITO_HAS_ERRORED,
  error: error
});



export const limpiarDatosCarrito = () => ({
  type: LIMPIAR_CARRITO
});
export const limpiarDatosListaNegra = () => ({
  type: LIMPIAR_LISTA_NEGRA
});
export const ProductosCarritoIsLoading = (loading = true) => ({
  type: PRODUCTO_CARRITO_IS_LOADING,
  loading: loading
});
export const ProductosCarrito = valor => ({
  type: SET_DATA_CARRITO_DETALLE,
  productosCarrito: valor
});

export const PlanesComparador = valor => ({
  type: SET_DATA_PlANES_COMPARADOR,
  planesComparador: valor
});

export const SetProductosCarrito = (data = {}) => {
  return dispatch => {
    dispatch(ProductosCarrito(data));
  };
};

export const SetValidarPlacasPoliza = () => ({
  type: VALIDAR_PLACAS_POLIZA
});

export function SetMsgValidarPlacasPoliza(payload) {
  return {
    type: MSG_VALIDAR_PLACAS_POLIZA,
    payload
  };
}
export const limpiarDatosValidacionesPlaca = () => ({
  type: LIMPIAR_DATOS_VALIDACIONES_PLACA
});

// Cotizador Hogar ----------------------------------------------
export const setCarritoHogar = createAction("SET_CARRITO_HOGAR");
export const carritoHogarError = createAction("CARRITO_HOGAR_ERROR");
export const carritoHogarloading = createAction("CARRITO_HOGAR_LOADING");
export const limpiarCarritoHogar = createAction("LIMPIAR_CARRITO_HOGAR");

export const setPlanesHogarAdvance = createAction("SET_PLANES_HOGAR_ADVANCE");
export const planesHogarAdvanceError = createAction("PLANES_HOGAR_ADVANCE_ERROR");
export const planesHogarAdvanceLoading = createAction("PLANES_HOGAR_ADVANCE_LOADING");

export const setSeccionesCoberturasHogar = createAction("SET_SECCIONES_COBERTURAS_HOGAR");
export const seccionesCoberturasHogarloading = createAction("SECCIONES_COBERTURAS_HOGAR_LOADING");
export const seccionesCoberturasHogarError = createAction("SECCIONES_COBERTURAS_HOGAR_ERROR");
export const limpiarSeccionesCoberturasHogar = createAction("LIMPIAR_SECCIONES_COBERTURAS_HOGAR");
export const limpiarPlanesHogarAdvance = createAction("LIMPIAR_COBERTURAS_HOGAR_ADVANCE");

export const setCalculoPrimaHogar = createAction("SET_CALCULO_PRIMA_HOGAR");
export const calculoPrimaHogarloading = createAction("CALCULO_PRIMA_HOGAR_LOADING");
export const calculoPrimaHogarError = createAction("CALCULO_PRIMA_HOGAR_ERROR");
export const limpiarCalculoPrimaHogar = createAction("LIMPIAR_CALCULO_PRIMA_HOGAR");

export const setCalculoPrimaHogarErrores = createAction("SET_CALCULO_PRIMA_HOGAR_ERRORES");
export const limpiarErroresCalculoPrimaHogar = createAction("LIMPIAR_ERRORES_CALCULO_PRIMA_HOGAR");

export const setProductoActualHogar = createAction("SET_PRODUCTO_ACTUAL_HOGAR");
export const limpiarProductoActualHogar = createAction("LIMPIAR_PRODUCTO_ACTUAL_HOGAR");

export const setGenerarPdfCotizacionHogar = createAction("SET_GENERAR_PDF_COTIZACION_HOGAR");
export const generarPdfCotizacionHogarloading = createAction("GENERAR_PDF_COTIZACION_HOGAR_LOADING");
export const generarPdfCotizacionHogarError = createAction("GENERAR_PDF_COTIZACION_HOGAR_ERROR");

// manejo duplicidades hogar
export const setDuplicidadPolizaLoading = createAction("SET_DUPLICIDAD_POLIZA_LOADING");
export const setDuplicidadPolizaError = createAction("SET_DUPLICIDAD_POLIZA_ERROR");
export const setIsDuplicatePoliza = createAction("SET_IS_DUPLICATE_POLIZA");

// Fin Cotizador Hogar ----------------------------------------------

// totales cabecera----------------
export const setTotalesCabeceraCotizadores = createAction("SET_TOTALES_CABECERA_COTIZADORES");
export const limpiarTotalesCabeceraCotizadores = createAction("LIMPIAR_TOTALES_CABECERA_COTIZADORES");

export const setListaNegraLoading = createAction("SET_LISTA_NEGRA_LOADING");
export const setListaNegraError = createAction("SET_LISTA_NEGRA_ERROR");
export const setInListaNegra = createAction("SET_IN_LISTA_NEGRA");
export const setInListaNegraMensaje = createAction("SET_IN_LISTA_NEGRA_MENSAJE");
export const limpiarInListaNegra = createAction("LIMPIAR_IN_LISTA_NEGRA");

export const setDataPlanesCotizacion = createAction("SET_DATA_PLANES_COTIZACION");


//fin totales cabecera -----------

export const FetchDataProductosCarrito = idCarrito => async dispatch => {
  var url = `${urlListarCarrito}${idCarrito}`;

  dispatch(ProductosCarritoIsLoading());
  httpClient.get(url)
    .then(data => {
      console.log("carrito ", data)
      if (data.transaccion) {
        var prod = data.data;
        prod.ultimosDigitos = data.ultimosDigitos ? data.ultimosDigitos : '';
        let total = prod.carProductos.length;
        dispatch(countCarrito(total));
        dispatch(ProductosCarrito(prod));
      } else if (!data.transaccion) {
        dispatch(countCarrito(0));
        dispatch(ProductosCarrito({}));
        dispatch(ProductosCarritoHasErrored());
      }
    })
    .catch(response => {
      console.log('responseErrorDavid', response);
      dispatch(countCarrito(0));
      dispatch(ProductosCarritoHasErrored());
    });
};

/*

export const FetchAceptarEdadCarrito = params => {
  const { isLogin, codCore, valor } = params;
  var url = "";
  if (isLogin) url = `${urlAceptaEdadCarrito}${codCore}&valor=${valor}`;
  
  return dispatch => {
    dispatch(ProductosCarritoIsLoading());
    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (
          (data.iv !== undefined) &
          (data.Data !== undefined) &
          (data.key != undefined)
        ) {
          data = desencriptarTramaAES(data.Data, data.key, data.iv);

          if (data.transaccion) {
            const prod = data.data;
            //let total = prod.carProductos.length;
            let total=0;
            prod.carProductos.forEach(element => {
              const cantidad=parseInt(element.cantidad)
              total=total+cantidad;
              
            });
            dispatch(countCarrito(total));
            dispatch(ProductosCarrito(prod));
          } else if (!data.transaccion) {
            dispatch(countCarrito(0));
            dispatch(ProductosCarritoHasErrored());

            //dispatch(ProductosCarrito(data));
          }
        } else {
          dispatch(countCarrito(0));
          dispatch(ProductosCarritoHasErrored());
        }
      })
      .catch(response => {
        dispatch(ProductosCarritoHasErrored());
        dispatch(ProductosCarrito({}));
        dispatch(countCarrito(0));
        //dispatch(ProductosCarritoIsLoading(false));
      });
  };
};


*/
export const FetchModificarCarrito =
  param => {
    var url = `${urlModificarCarrito}`;


    switch (param.codigoProductoEspecial) {
      case 'comparador':
        url = urlModificarCarritoComparador
        break;
      case 'pits':
        url = urlModificarCarritoPits
        break;

      default:
        break;
    }

    if (param.codigoProductoEspecial == 'comparador') {
      param.codigoProductoEspecial = null

    }
    console.log('vercache', url)
    return async dispatch => {
      dispatch(ProductosCarritoIsLoading());
      await fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json"
        },
        body: JSON.stringify(param)
      })
        .then(response => response.json())
        .then(data => {


          console.log('vercache', data)
          /*
          if (
            (data.iv !== undefined) &
            (data.Data !== undefined) &
            (data.key != undefined)
          ) {
            data = desencriptarTramaAES(data.Data, data.key, data.iv);*/


          if (data.transaccion) {

            if (data.planes) {
              dispatch(setDataPlanesCotizacion(data.planes))
            }

            const ds = data.data;
            let total = ds.carProductos.length;
            let datos = {
              mostrarPropietarioCarrito: data.mostrarPropietarioCarrito,
              ...ds
            }








            dispatch(countCarrito(total));
            dispatch(ProductosCarrito(datos));
          } else {
            console.log('verErrores', data)
            dispatch(ProductosCarritoHasErrored(data.errorDescripcion));
            //dispatch(ProductosCarrito(ds));
            dispatch(countCarrito(0));
          }

        })
        .catch(response => {
          //console.log(response)
          dispatch(ProductosCarritoHasErrored());
          //dispatch(ProductosCarrito(response));
        });
    };
  };

export const FetchModificarCarritoRenovacion =
  (param) => {
    param.productoExterno = false
    var url = `${urlModificarCarritoRenovacion}`;


    switch (param.codigoProductoEspecial) {
      case 'externo':
        param.productoExterno = true
        break;

      default:
        break;
    }

    if (param.codigoProductoEspecial == 'comparador') {
      param.codigoProductoEspecial = null

    }
    console.log('vercache', url)
    return async dispatch => {
      dispatch(ProductosCarritoIsLoading());
      return httpClient.post(url, param)
        .then(data => {


          console.log('vercache', data)
          /*
          if (
            (data.iv !== undefined) &
            (data.Data !== undefined) &
            (data.key != undefined)
          ) {
            data = desencriptarTramaAES(data.Data, data.key, data.iv);*/


          if (data.transaccion) {

            if (data.planes) {
              dispatch(setDataPlanesCotizacion(data.planes))
            }

            const ds = data.data;
            let total = ds.carProductos.length;
            let datos = {
              mostrarPropietarioCarrito: data.mostrarPropietarioCarrito,
              ...ds
            }








            dispatch(countCarrito(total));
            dispatch(ProductosCarrito(datos));
          } else {
            console.log('verErrores', data)
            dispatch(ProductosCarritoHasErrored(data.errorDescripcion));
            //dispatch(ProductosCarrito(ds));
            dispatch(countCarrito(0));
          }

        })
        .catch(response => {
          //console.log(response)
          dispatch(ProductosCarritoHasErrored());
          //dispatch(ProductosCarrito(response));
        });
    };
  };

export const FetchRecalcularCarrito = idCarrito => async dispatch => {
  var url = `${urlRecalcularCarrito}${idCarrito}`;

  dispatch(ProductosCarritoIsLoading());
  httpClient.get(url)
    .then(data => {
      console.log("carrito ", data)
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        var prod = data.data;
        prod.ultimosDigitos = data.ultimosDigitos ? data.ultimosDigitos : '';
        //let total = prod.carProductos.length;
        let total = prod.carProductos.length;
        dispatch(countCarrito(total));
        dispatch(ProductosCarrito(prod));
      } else if (!data.transaccion) {
        dispatch(countCarrito(0));
        dispatch(ProductosCarrito({}));
        dispatch(ProductosCarritoHasErrored());

        //dispatch(ProductosCarrito(data));
      }
      /*} else {
        dispatch(countCarrito(0));
        dispatch(ProductosCarritoHasErrored());
      }*/
    })
    .catch(response => {
      console.log('responseErrorDavid', response);
      // dispatch(ProductosCarritoHasErrored());
      // dispatch(ProductosCarrito({}));
      // dispatch(countCarrito(0));
      // FetchDataProductosCarrito(idCarrito)
      dispatch(ProductosCarritoIsLoading(false));
    });

};
/*
export const FetchModificarCompraCarrito = params => {
  const { isLogin, codCore, clihash, id, cantidad, accion, history } = params;
  var url = "";
  if (isLogin)
    url = `${urlModificarCrearCarritoCODCORE}${codCore}&proCodigoCore=${id}&cantidad=${cantidad}${accion}`;
  else
    url = `${urlModificarCrearCarritoHASH}${clihash}&proCodigoCore=${id}&cantidad=${cantidad}${accion}`;

  return dispatch => {
    dispatch(ProductosCarritoIsLoading(true));

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (
          (data.iv !== undefined) &
          (data.Data !== undefined) &
          (data.key != undefined)
        ) {
          data = desencriptarTramaAES(data.Data, data.key, data.iv);

          ////console.log(data);

          if (data.transaccion) {
            const ds = data.data;
            //let total = ds.carProductos.length;
            let total=0;
            ds.carProductos.forEach(element => {
              const cantidad=parseInt(element.cantidad)
              total=total+cantidad;
              
            });
            dispatch(countCarrito(total));
            dispatch(ProductosCarrito(ds));
            history.push({
              pathname: "/carrito-compras",
              state: { paso: 0 }
            });
          } else {
            dispatch(ProductosCarritoHasErrored());
            dispatch(countCarrito(0));
            //dispatch(ProductosCarrito(data));
          }
        } else {
          dispatch(ProductosCarritoHasErrored());
          dispatch(countCarrito(0));
          //dispatch(ProductosCarrito(data));
        }
      })
      .catch(response => {
        dispatch(ProductosCarritoHasErrored());
        //dispatch(ProductosCarrito(response));
      });
  };
};
*/



export const FetchGuardarDatosAdiconalesCarrito = (param, array) => {
  var url = `${urlGuardarDatosAdiconalesCarrito}`;
  return async dispatch => {
    dispatch(ProductosCarritoIsLoading());
    await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json"
      },
      body: JSON.stringify(param)
    })
      .then(response => response.json())
      .then(data => {
        if (data.transaccion) {
          let ObtenerProducto = array.productosCarrito.carProductos.filter((producto) =>
            producto.datosProducto.placa === data.placa
          )
          //Actualizar valores 
          ObtenerProducto[0].datosProducto.chasis = data.valoresActualizar.chasis
          ObtenerProducto[0].datosProducto.motor = data.valoresActualizar.motor
          ObtenerProducto[0].datosProducto.color = data.valoresActualizar.color
          ObtenerProducto[0].datosProducto.tipo = data.valoresActualizar.tipo
          ObtenerProducto[0].datosProducto.capacidad = data.valoresActualizar.capacidad
          let listadoProductos = [];
          array.productosCarrito.carProductos.forEach(function (producto) {
            if (producto.datosProducto.placa === data.placa) {
              listadoProductos.push(ObtenerProducto[0]);
            }
            else {
              listadoProductos.push(producto);
            }
          });
          array.productosCarrito.carProductos = listadoProductos;

          dispatch(setConsultaPlaca(ObtenerProducto[0].datosProducto));
          dispatch(ProductosCarrito(array.productosCarrito));
        }
        else {
          dispatch(ProductosCarritoHasErrored());
        }
      })
      .catch(response => {
        //console.log(response)
        dispatch(ProductosCarritoHasErrored());
      });
  };
};


export const FetchValidarPlacasPolizaCarrito = (param, esRenovacion) => {
  var url = `${urlValidarPlacaSinPolizaCarrito}`;
  return async dispatch => {
    dispatch(ProductosCarritoIsLoading());
    await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json"
      },
      body: JSON.stringify(param)
    })
      .then(response => response.json())
      .then(data => {

        let resultado = data;
        if (esRenovacion) {
          dispatch(ProductosCarritoIsLoading(false));
          resultado.tienePoliza = false
        }
        if (resultado.transaccion) {
          if (resultado.tienePoliza !== false) {
            dispatch(SetValidarPlacasPoliza());
            dispatch(SetMsgValidarPlacasPoliza(resultado.mensajeValidarPlacas ? resultado.mensajeValidarPlacas : resultado.mensajeIngresarPlacas));
            dispatch(ProductosCarritoIsLoading(false));
          }
          else if (resultado.mensajeIngresarPlacas !== undefined && resultado.mensajeIngresarPlacas !== null) {
            dispatch(SetValidarPlacasPoliza());
            dispatch(SetMsgValidarPlacasPoliza(resultado.mensajeIngresarPlacas));
            dispatch(ProductosCarritoIsLoading(false));
          }
        }
        else {
          dispatch(ProductosCarritoHasErrored());
          dispatch(ProductosCarritoIsLoading(false));
        }
      })
      .catch(response => {
        dispatch(ProductosCarritoIsLoading(false));
        dispatch(ProductosCarritoHasErrored());
      });
  };
};

// Cotizador Hogar ----------------------------------------------

/**
 * 
 * @param {hogar|pymes|otros} type tipo de cotizador 
 * @param {Object} postObj body con información de la persona a consultar
 * @returns {Object} Objeto con la respuesta del servidor
 */
export const isDuplicateHogar = ({ type, postObj }) => async dispatch => {
  // url dependiendo el caso
  let url = '';
  if (type === 'hogar') {
    url = `${urlConsultarDuplicidadHogar}`;
  };
  if (type === 'pymes') {
    url = `${urlConsultarDuplicidadPymes}`;
  };
  if (type === 'otros') {
    url = `${urlConsultarDuplicidad}`;
  };


  // regresar error de redux al estado inicial
  dispatch(setDuplicidadPolizaError(false));
  // is loading true
  dispatch(setDuplicidadPolizaLoading(true));
  // fetch post
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(postObj)
  })
    .then(response => response.json())
    .then(data => {
      const transaccion = data.transaccion;
      console.log('transaction is ...', data);
      if (transaccion) {
        dispatch(setIsDuplicatePoliza(data.tienePolizaVigente));
      } else {
        console.log('error_is ...1');
        dispatch(setDuplicidadPolizaError(true));
      }
    })
    .catch(() => {
      console.log('error_is ...2');
      dispatch(setDuplicidadPolizaError(true));
    });
  // is loading false
  console.log('is loading false');
  dispatch(setDuplicidadPolizaLoading(false));
}

/**
 * 
 * @param {identificacion} identificacion No. de identificación a consultar
 * @returns {Object} Objeto con la respuesta del servidor
 */
export const estaEnListaNegra = (identificacion, datosUsuarios) => async dispatch => {
  // url dependiendo el caso
  let url = urlConsultarListaNegra + identificacion;


  // regresar error de redux al estado inicial
  dispatch(setListaNegraError(false));
  // is loading true
  dispatch(setListaNegraLoading(true));
  // fetch post
  const data = await apiPost(url, datosUsuarios)


  if (!data.transaccion) {
    dispatch(setInListaNegra(true));
    dispatch(setInListaNegraMensaje(data.mensaje));
    console.log('data.mensaje', data.mensaje)
  } else {

    dispatch(setInListaNegra(false));
    dispatch(setInListaNegraMensaje(''));

    dispatch(setListaNegraError(false));
  }


  dispatch(setListaNegraLoading(false));
}


// fetch data carrito hogar
export const FetchDataCarritoHogar = param => async dispatch => {
  var url = `${urlCarritoHogar}`;
  dispatch(carritoHogarloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setCarritoHogar(data.datosActuales));
      } else {
        dispatch(carritoHogarError());
      }
    })
    .catch(() => {
      dispatch(carritoHogarError());
    });
};
export const LimpiarCarritoHogar = () => async dispatch => {
  dispatch(limpiarCarritoHogar());
};

export const LimpiarListaNegra = () => async dispatch => {
  dispatch(setInListaNegraMensaje(''));
  dispatch(setInListaNegra(false));
};
export const setProductoActualCotizadoHogar = param => async dispatch => {
  dispatch(limpiarProductoActualHogar());
  dispatch(setProductoActualHogar(param));
};
export const limpiarProductoActualCotizadoHogar = () => async dispatch => {
  dispatch(limpiarProductoActualHogar());
};

export const FetchDataSeccionesCoberturasHogar = param => async dispatch => {
  var url = `${urlListarSeccionesCoberturasHogar}`;
  dispatch(limpiarSeccionesCoberturasHogar());
  dispatch(seccionesCoberturasHogarloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setSeccionesCoberturasHogar(data.secciones));
      } else {
        dispatch(seccionesCoberturasHogarError());
      }
    })
    .catch(() => {
      dispatch(seccionesCoberturasHogarError());
    });
};

export const FetchDataCoberturasHogarAdvance = () => async dispatch => {
  var url = `${urlListarCoberturasHogarAdvance}`;
  dispatch(limpiarPlanesHogarAdvance());
  dispatch(planesHogarAdvanceLoading(true));
  await fetch(url, {
    method: "get",
    headers: {
      Accept: "application/json"
    }
  })
    .then(response => response.json())
    .then(data => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setPlanesHogarAdvance(data));
      } else {
        dispatch(planesHogarAdvanceError());
      }
    })
    .catch(() => {
      dispatch(planesHogarAdvanceError());
    });
};

export const FetchCalculoPrimaHogar = param => async dispatch => {
  var url = `${urlCalcularPrimasHogar}`;
  dispatch(limpiarCalculoPrimaHogar());
  dispatch(calculoPrimaHogarloading());
  dispatch(limpiarErroresCalculoPrimaHogar());

  try {
    const res = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json"
      },
      body: JSON.stringify(param)
    })

    const data = await res.json();

    const transaccion = data.transaccion;
    if (transaccion) {
      dispatch(setCalculoPrimaHogar(data));
      dispatch(limpiarErroresCalculoPrimaHogar());

    } else {
      dispatch(calculoPrimaHogarError());
      dispatch(limpiarErroresCalculoPrimaHogar());
      dispatch(setCalculoPrimaHogarErrores(data));
    }

  } catch (error) {
    dispatch(calculoPrimaHogarError());
    dispatch(limpiarErroresCalculoPrimaHogar());

  }
};
export const limpiarTotalesHogar = () => async dispatch => {
  dispatch(limpiarCalculoPrimaHogar());
};

export const FetchListarCarritoHogar = param => async dispatch => {
  var url = `${urlRecuperarCarritoHogar}`;
  dispatch(limpiarCarritoHogar());
  dispatch(carritoHogarloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setCarritoHogar(data));
      } else {
        dispatch(carritoHogarError());
      }
    })
    .catch(() => {
      dispatch(carritoHogarError());
    });
};

export const FetchGenerarEnviarPdfHogar = param => async dispatch => {
  var url = `${urlGenerarEnviarCotizacionHogar}`;
  dispatch(generarPdfCotizacionHogarloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setGenerarPdfCotizacionHogar(data));
      } else {
        dispatch(generarPdfCotizacionHogarError());
      }
    })
    .catch(() => {
      dispatch(generarPdfCotizacionHogarError());
    });
};

// Fin Cotizador Hogar ----------------------------------------------


//action para precargar información de cabecera del carrito --------------------------
export const FetchTotalesCabeceraCotizadores = param => async dispatch => {
  dispatch(limpiarTotalesCabeceraCotizadores());
  dispatch(setTotalesCabeceraCotizadores(param));
};

// FIN action para precargar información de cabecera del carrito --------------------------